import React from "react";
import {
  Alert,
  Box,
  Button,
  KeyValuePairs,
  Popover,
  SpaceBetween,
} from "@amzn/awsui-components-react";
import { OmsReport } from "../../lusca-search-api/generated-src";
import OMSReportFreshness from "./OMSReportFreshness";
import { reportTimestamp } from "./OMSReportSchedule";
import { fileSize } from "./omsReportFormatting";

export default function OMSExportSource({
  report,
  availableReport,
  accepted,
  onUseLatest,
}: {
  report: OmsReport;
  availableReport: OmsReport;
  accepted: boolean;
  onUseLatest: () => void;
}) {
  const newer = report.snapshotId !== availableReport.snapshotId;
  return (
    <section aria-label="Source report">
      <SpaceBetween size="s">
        <div className="oms-report-download__section-heading">
          <Box variant="h3">
            {newer && accepted ? "Original source report" : "Source report"}
          </Box>
          <Popover
            header="Source snapshot"
            size="large"
            triggerType="text"
            content={
              <SpaceBetween size="s">
                <Box>Snapshot ID: {report.snapshotId}</Box>
                <Box>Published: {reportTimestamp(report.exportedAt)}</Box>
              </SpaceBetween>
            }
          >
            Snapshot details
          </Popover>
        </div>
        <KeyValuePairs
          columns={3}
          items={[
            {
              label: "Data refreshed",
              value: (
                <time dateTime={report.sourceRefreshedAt}>
                  {reportTimestamp(report.sourceRefreshedAt)}
                </time>
              ),
            },
            { label: "Source rows", value: report.rowCount.toLocaleString() },
            { label: "Source size", value: fileSize(report.totalBytes) },
          ]}
        />
        <OMSReportFreshness sourceRefreshedAt={report.sourceRefreshedAt} />
        {newer && (
          <Alert
            type="info"
            header="A newer source report is available"
            action={
              !accepted && (
                <Button onClick={onUseLatest}>Use newer report</Button>
              )
            }
          >
            {accepted
              ? "This export keeps its original source. Choose Edit settings, then Use newer report to apply your settings to newer data."
              : "This configuration still uses the source shown. Choose Use newer report to apply it to the newer source."}{" "}
            Newer data refreshed:{" "}
            {reportTimestamp(availableReport.sourceRefreshedAt)}.
          </Alert>
        )}
      </SpaceBetween>
    </section>
  );
}
